/**
 * Hook to parse and return URL parameters for the StorageForm
 */
export function useStorageFormParams() {
  const queryStr = window.location.search
  const urlParams = new URLSearchParams(queryStr)

  return {
    spaceId: urlParams.get('id'),
    hasSigned: urlParams.get('hasSigned') === "true",
    formSubmitted: urlParams.get('formSubmitted') === "true",
    invoiceNumber: urlParams.get('invoiceNumber'),
    contractId: urlParams.get('esio_contract_id'),
    paidCustomerId: urlParams.get('customerCode'),
    paidAmount: urlParams.get('amount'),
    transactionId: urlParams.get('transactionId'),
    paidDate: urlParams.get('paidDate'),
    payMethod: urlParams.get('payMethod'),
  }
}
